import type { ApprovedCelebrationLineItem } from "@/hooks/queries/useCelebrations";

/** Extract the primary SKU id from an approved recommendation payload. */
export function primarySkuIdFromLineItems(
  lineItems: ApprovedCelebrationLineItem[] | null | undefined,
): string | null {
  if (!lineItems?.length) return null;
  const withSku = lineItems.find(
    (li) => typeof li.sku_id === "string" && li.sku_id.length === 36,
  );
  return withSku?.sku_id ?? null;
}

export interface CelebrationCheckoutContext {
  celebrationId: string;
  recipientId: string;
  recipientName: string;
  occasion: string;
  defaultDate: string;
  skuId: string;
}
